/* AURA Studio RC1.1.2 — Keep logo visible when nav hides */
(() => {
  const body = document.body;
  if (!body) return;

  const config = {
    enabled: true,
    threshold: 120
  };

  const hasOpenHeaderUI = () => {
    return !!document.querySelector(
      '.shopify-section-group-header-group details[open], .shopify-section-group-header-group .menu-opening, .search-modal[open]'
    );
  };

  let lastY = window.scrollY;
  let ticking = false;

  const update = () => {
    const y = window.scrollY;
    const goingDown = y > lastY;
    const shouldHide = config.enabled && goingDown && y > config.threshold && !hasOpenHeaderUI();

    body.classList.toggle('aura-rc-hide-nav-keep-logo', shouldHide);
    body.classList.toggle('aura-rc-menu-open', hasOpenHeaderUI());

    lastY = y;
    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  document.addEventListener('click', () => setTimeout(update, 60));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      body.classList.remove('aura-rc-hide-nav-keep-logo');
    }
  });

  update();
})();
